import * as React from 'react';
import { Box, Tabs, Tab, Grid } from '@mui/material';

import Log from '@/Logger';
import { type User } from '@/auth';

import CsvList from "./CsvList";
import PdfList from "./PdfList";
import PdfViewer from "./PdfEdit/pdf-viewer";

type Props = {
    user: User
    isVisiblePdfEdit?: boolean; // PDF編集画面の表示状態。trueの場合はPDF編集画面を表示する。
    setIsVisiblePdfEdit?: React.Dispatch<React.SetStateAction<boolean>>;
    isConflict?: boolean;
    setIsConflict?: React.Dispatch<React.SetStateAction<boolean>>;
}

export type PdfEditProps = {
    docId: string;
    serialId: string;
    deviceId: string;
    deviceName: string;
}

const List = (props: Props) => {
    const logger = Log.getLogger();

    const tenantId = props.user.tenantId;
    const pdfPath = 'stable/pdf/' + tenantId + '/'
    const csvPath = 'stable/csv/' + tenantId + '/'
    const searchPath = 'stable/text_index/' + tenantId + '/'

    const pdfTabName: string = 'デバイス内のドキュメント一覧'
    const csvTabName: string = 'CSV出力'

    const [tab, setTab] = React.useState(0);
    const [pdfEditProp, setPdfEditProp] = React.useState<PdfEditProps>({ docId: "", serialId: "", deviceId: "", deviceName: "" });

    const handleTabChange: (event: React.SyntheticEvent, newValue: number) => void = (event: React.SyntheticEvent, newValue: number) => {
        logger.ui.info('List', 'handleTabChange');
        setTab(newValue);
    };

    interface TabPanelProps {
        children?: React.ReactNode;
        index: number;
        value: number;
        style?: React.CSSProperties;
    }

    function TabPanel(props: TabPanelProps) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <>
                        {children}
                    </>
                )}
            </div>
        );
    }

    return (
        <>
            {!(props.isVisiblePdfEdit)
                // PDF/CSV一覧
                ? (< Grid container >
                    <Grid size={12} display='flex' justifyContent='center'>
                        <Box display='flex' flexDirection='column' sx={{ width: '100%' }}>
                            <Box flexGrow='0' sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={tab} onChange={handleTabChange} aria-label="basic tabs example" variant="fullWidth">
                                    <Tab label={pdfTabName} id='simple-tab-1' aria-controls='simple-tabpanel-1' />
                                    <Tab label={csvTabName} id='simple-tab-2' aria-controls='simple-tabpanel-2' />
                                </Tabs>
                            </Box>
                            <TabPanel value={tab} index={0} style={{ flexGrow: 1 }} >
                                <PdfList path={pdfPath} searchpath={searchPath} tenantid={tenantId} setIsVisiblePdfEdit={props.setIsVisiblePdfEdit} setPdfEditProp={setPdfEditProp} />
                            </TabPanel>
                            <TabPanel value={tab} index={1} style={{ flexGrow: 1 }}>
                                <CsvList path={csvPath} />
                            </TabPanel>
                        </Box>

                    </Grid>
                </Grid >)
                // フォーム編集画面
                : (<PdfViewer
                    tenantId={tenantId}
                    device={{
                        serialId: pdfEditProp.serialId,
                        deviceId: pdfEditProp.deviceId,
                        name: pdfEditProp.deviceName,
                    }}
                    docId={pdfEditProp.docId}
                    setIsPDFEditVisible={props.setIsVisiblePdfEdit}
                    setIsConflict={props.setIsConflict}
                />)}
        </>
    )
};

export default List;
